var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingUploadDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.458 1.66699C10.8546 1.66701 11.2351 1.82407 11.5156 2.10449L16.1436 6.73242C16.4239 7.0129 16.5811 7.39349 16.5811 7.79004V15.9824C16.5811 17.2805 15.5286 18.333 14.2305 18.333H5.68359C4.38557 18.3329 3.33301 17.2805 3.33301 15.9824V4.01758C3.33301 2.71953 4.38557 1.66708 5.68359 1.66699H10.458ZM5.68359 2.94824C5.09362 2.94833 4.61523 3.42759 4.61523 4.01758V15.9824C4.61523 16.5724 5.09362 17.0517 5.68359 17.0518H14.2305C14.8205 17.0518 15.2988 16.5725 15.2988 15.9824V7.79004C15.2988 7.73337 15.2764 7.67874 15.2363 7.63867L10.6094 3.01172C10.5693 2.97166 10.5147 2.94826 10.458 2.94824H5.68359ZM9.41895 6.85449C9.6693 6.60436 10.0749 6.60422 10.3252 6.85449L12.8887 9.41895C13.139 9.66928 13.139 10.0749 12.8887 10.3252C12.6383 10.5752 12.2327 10.5754 11.9824 10.3252L10.5127 8.85547V12.4355C10.5127 12.7895 10.226 13.077 9.87207 13.0771C9.51804 13.0771 9.23047 12.7896 9.23047 12.4355V8.85547L7.76074 10.3252C7.51043 10.5753 7.10479 10.5754 6.85449 10.3252C6.60421 10.0749 6.60431 9.66929 6.85449 9.41895L9.41895 6.85449Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingUploadDocument);
export default __webpack_public_path__ + "static/media/onboarding-upload-document.7693701c2612c1899cb69e2c6e4ad81e.svg";
export { ForwardRef as ReactComponent };